(ns io.daskul.webapp.widgets.form.picker-modal
  "Generic picker modal for selecting items from API.

   No domain knowledge - works with any child aggregate format.
   Displays items using column definitions from child aggregate."
  (:require
   [uix.core :as uix :refer [defui $]]
   [ajax.core :as ajax]
   [io.daskul.webapp.ui :as ui]
   [io.daskul.webapp.api.client :as client]))

(defui picker-modal
  "Generic picker modal. Fetches items from API and displays using child aggregate fields.

   Props:
   - config: Map with :url, :label, :params, :response-path
   - form-data: Parent form state (for building query params)
   - columns: Column definitions from child aggregate (for display)
   - on-select: (fn [item]) - Called when user clicks an item
   - on-close: (fn []) - Called when modal is closed"
  [{:keys [config form-data columns on-select on-close]}]
  (let [[items set-items!] (uix/use-state [])
        [loading? set-loading!] (uix/use-state true)
        [error set-error!] (uix/use-state nil)

        {:keys [url label params response-path]
         :or {response-path [:items]
              label "Select Items"}} config

        ;; Build query params by mapping config keys to form-data values
        query-params (reduce-kv
                      (fn [acc param-key form-field]
                        (assoc acc param-key (get form-data form-field)))
                      {}
                      params)

        ;; Fetch items on mount
        _ (uix/use-effect
           (fn []
             (set-loading! true)
             (set-error! nil)
             (ajax/GET (str client/api-url url)
                       {:params query-params
                        :headers (client/auth-header)
                        :format (ajax/json-request-format)
                        :response-format (ajax/json-response-format {:keywords? true})
                        :handler (fn [response]
                                   (set-items! (get-in response response-path []))
                                   (set-loading! false))
                        :error-handler (fn [_err]
                                         (set-error! "Failed to load items")
                                         (set-loading! false))})
             js/undefined)
           [url query-params response-path])]

    ($ ui/modal
      {:opened true
       :onClose on-close
       :title label
       :centered true
       :size "md"}
      ($ ui/stack {:gap "md"}
        (cond
          loading?
          ($ ui/centered-loader {:label "Loading..."})

          error
          ($ ui/error-alert error)

          (empty? items)
          ($ ui/empty-alert {:title "No items"}
            "No items available")

          :else
          ;; Display items using first 2 columns
          ($ ui/stack {:gap "xs"}
            (for [item items]
              ($ ui/paper
                {:key (or (:id item) (:source-id item))
                 :p "sm"
                 :withBorder true
                 :style {:cursor "pointer"}
                 :onClick #(on-select item)
                 :className "picker-item"}
                ($ ui/group {:justify "space-between" :align "center"}
                  ;; Display first two columns from child aggregate
                  (for [{:keys [key label]} (take 2 columns)]
                    ($ ui/text
                      {:key (name key)
                       :size "sm"
                       :className (name key)}
                      (get item key))))))))))))
